import React from 'react';
import { useMentionClickNavigation } from '../hooks/useMentionClickNavigation';
import { useMentionHover } from '../hooks/useMentionHover';
import { MentionHoverCard } from './MentionHoverCard';

export const MentionClickHandler: React.FC = () => {
  const {
    hovered,
    hoverCardContentRef,
    closeHover,
    onHoverCardMouseEnter,
    onHoverCardMouseLeave,
  } = useMentionHover();
  useMentionClickNavigation({ onActivate: closeHover });

  return (
    <MentionHoverCard
      hovered={hovered}
      hoverCardContentRef={hoverCardContentRef}
      onClose={closeHover}
      onHoverCardMouseEnter={onHoverCardMouseEnter}
      onHoverCardMouseLeave={onHoverCardMouseLeave}
    />
  );
};
